import { useState, useEffect, useRef } from "react";
import ConfirmDialog from "./ui/ConfirmDialog";
import { useApi } from "../hooks/useApi";

export default function FirstTimeEmailScheduleButton({ setDeadlinepassed }) {
    const [showButton, setShowButton] = useState(false);

    const initialized = useRef(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [msg, setMsg] = useState(false);
    const { apiCall } = useApi();

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            apiCall(`isEmailScheduleNeeded`, {
                credentials: "include",
            }) // Update with your actual API endpoint
                .then((response) => {
                    return response.json();
                }).then((data) => {
                    if (data.success) {
                        setMsg(data.message);
                        setShowButton(true);
                    }
                });
        }
    });

    const scheduleEmails = () => {
        if (inProgress) return;

        setInProgress(true);

        let success = false;
        apiCall(`manuallyScheduleFirstEmailQueue`, {
            method: "POST",
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setShowButton(false);
                    setIsDialogOpen(false);
                    success = true;
                    if (data.message) {
                        alert(data.message);
                    }
                } else {

                    if (data.error) {
                        alert(data.error);
                    }
                    else {
                        alert("Error setting up notifications.");
                    }

                }

            }).finally((data) => {
                setInProgress(false);

            });

    };

    return (
        <div>
            {showButton && (
                <>
                    <div className="text-gray-700 font-medium mb-2 text-center">
                        <button onClick={() => { setIsDialogOpen(true) }} className="mt-3 cursor-pointer bg-amber-600 text-amber-50 p-2  hover:bg-amber-500 rounded-full transition-colors">Notify the Users</button>
                    </div>
                    <ConfirmDialog
                        open={isDialogOpen}
                        title="Emails Confirmation"
                        message={(msg ? msg : '')}
                        confirmText="Send"
                        cancelText="Cancel"
                        onConfirm={scheduleEmails}
                        inProgress={inProgress}
                        onCancel={() => setIsDialogOpen(false)}
                    />
                </>



            )}
        </div>

    );
};
